var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active||_vm.locked),expression:"active||locked"}],class:['spinner spinner-gritcode',_vm.spinnerSize,{'spinner-fixed':_vm.fixed}]},[_c('div',{staticClass:"spinner-wrapper"},[_c('div',{staticClass:"spinner-circle"}),_vm._v(" "),_c('div',{staticClass:"spinner-text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7322695c","hasScoped":false,"buble":{"transforms":{}}}!./src/spinner/template.html
// module id = 193
// module chunks = 0